import * as React from 'react'

type SidebarLiveIconProps = React.SVGProps<SVGSVGElement> & {
  active?: boolean
  size?: number | string
}

export const SidebarLiveIcon = React.forwardRef<SVGSVGElement, SidebarLiveIconProps>(
  ({ active = false, size = 24, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g transform="translate(-1, -2) scale(1.08)">
          <path
            d="M21.5853 26.0509C23.9911 26.0509 25.9414 24.0515 25.9414 21.585C25.9414 19.1186 23.9911 17.1191 21.5853 17.1191C19.1795 17.1191 17.2292 19.1186 17.2292 21.585C17.2292 24.0515 19.1795 26.0509 21.5853 26.0509Z"
            fill="#62C8DB"
          />
          <path
            d="M12.5081 32.085C12.213 32.085 11.9102 31.9656 11.685 31.7347C9.04499 29.0202 7.58521 25.414 7.58521 21.585C7.58521 17.756 9.04499 14.1419 11.685 11.4353C12.1432 10.9656 12.8808 10.9656 13.3312 11.4353C13.7893 11.9049 13.7893 12.6612 13.3312 13.1229C11.126 15.3837 9.91466 18.3848 9.91466 21.585C9.91466 24.7852 11.126 27.7863 13.3312 30.0471C13.7893 30.5168 13.7893 31.273 13.3312 31.7347C13.106 31.9656 12.8032 32.085 12.5081 32.085Z"
            fill={active ? '#0B2948' : '#FBFBFB'}
          />
          <path
            d="M30.6623 32.085C30.3672 32.085 30.0644 31.9656 29.8392 31.7347C29.3811 31.2651 29.3811 30.5088 29.8392 30.0471C32.0444 27.7863 33.2557 24.7852 33.2557 21.585C33.2557 18.3848 32.0444 15.3837 29.8392 13.1229C29.3811 12.6532 29.3811 11.897 29.8392 11.4353C30.2973 10.9656 31.035 10.9656 31.4853 11.4353C34.1332 14.1498 35.5852 17.748 35.5852 21.585C35.5852 25.422 34.1254 29.0202 31.4853 31.7347C31.2602 31.9656 30.9573 32.085 30.6623 32.085Z"
            fill={active ? '#0B2948' : '#FBFBFB'}
          />
          <path
            d="M27.4477 28.7895C27.1526 28.7895 26.8498 28.6701 26.6246 28.4393C26.1665 27.9696 26.1665 27.2133 26.6246 26.7516C27.9679 25.3745 28.7133 23.5356 28.7133 21.5852C28.7133 19.6349 27.9757 17.796 26.6246 16.4188C26.1665 15.9491 26.1665 15.1929 26.6246 14.7312C27.0827 14.2615 27.8204 14.2615 28.2707 14.7312C30.0567 16.5621 31.0428 18.998 31.0428 21.5852C31.0428 24.1724 30.0567 26.6083 28.2707 28.4393C28.0456 28.6701 27.7427 28.7895 27.4477 28.7895Z"
            fill={active ? '#0B2948' : '#FBFBFB'}
          />
          <path
            d="M15.7228 28.7895C15.4277 28.7895 15.1249 28.6701 14.8997 28.4393C13.1138 26.6083 12.1277 24.1724 12.1277 21.5852C12.1277 18.998 13.1138 16.5621 14.8997 14.7312C15.3579 14.2615 16.0955 14.2615 16.5459 14.7312C17.004 15.2008 17.004 15.9571 16.5459 16.4188C15.2026 17.796 14.4571 19.6349 14.4571 21.5852C14.4571 23.5356 15.1948 25.3665 16.5459 26.7516C17.004 27.2213 17.004 27.9776 16.5459 28.4393C16.3207 28.6701 16.0179 28.7895 15.7228 28.7895Z"
            fill={active ? '#0B2948' : '#FBFBFB'}
          />
        </g>
      </svg>
    )
  },
)

SidebarLiveIcon.displayName = 'SidebarLiveIcon'
